import { NodeRepeatNotificationDTO, RepeatAlertSettings } from '.';
import {
    IChangeRepeatAlertSelected,
    IGetRepeatSettingsFailure,
    IGetRepeatSettingsRequest,
    IGetRepeatSettingsSuccess,
    IRepeatAlertSettings,
    ISetRepeatSettingsBySockets,
    ISetRepeatSettingsFailure,
    ISetRepeatSettingsRequest,
    ISetRepeatSettingsSuccess,
    REPEAT_ALERT,
} from './types';

export function getRepeatAlert(): IGetRepeatSettingsRequest {
    return { type: REPEAT_ALERT.GET_NODE_SETTINGS_REQUEST };
}

export function getRepeatAlertSuccess(value: NodeRepeatNotificationDTO): IGetRepeatSettingsSuccess {
    return { type: REPEAT_ALERT.GET_NODE_SETTINGS_SUCCESS, payload: value };
}

export function getRepeatAlertFailure(): IGetRepeatSettingsFailure {
    return { type: REPEAT_ALERT.GET_NODE_SETTINGS_FAILURE };
}

export function setRepeatAlert(value: NodeRepeatNotificationDTO): ISetRepeatSettingsRequest {
    return { type: REPEAT_ALERT.SET_NODE_SETTINGS_REQUEST, payload: value };
}

export function setRepeatAlertSuccess(value: NodeRepeatNotificationDTO): ISetRepeatSettingsSuccess {
    return { type: REPEAT_ALERT.SET_NODE_SETTINGS_SUCCESS, payload: value };
}

export function setRepeatAlertFailure(value: any): ISetRepeatSettingsFailure {
    return { type: REPEAT_ALERT.SET_NODE_SETTINGS_FAILURE, payload: value };
}

export function setRepeatAlertsSettings(value: RepeatAlertSettings): IRepeatAlertSettings {
    return { type: REPEAT_ALERT.SET_SETTINGS, payload: value };
}
export function changeRepeatAlertsSelected(value: number): IChangeRepeatAlertSelected {
    return { type: REPEAT_ALERT.CHANGE_SELECTED, payload: value };
}
export function setRepeatAlertSockets(value: NodeRepeatNotificationDTO): ISetRepeatSettingsBySockets {
    return { type: REPEAT_ALERT.SET_NODE_SETTINGS_SUCCESS_By_Sockets, payload: value };
}
